import * as React from 'react';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';
import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import { toggleDragginClass } from '../../../../../lib/helpers';

export interface IImagesItemProps {
  image: string;
  connectDragSource?(element: JSX.Element): JSX.Element;
  connectDragPreview?(element: HTMLElement): void;
  isDragging?: boolean;
  type: string;
}

class ImageItem extends React.Component<IImagesItemProps> {

  componentDidMount() {
    const img = new Image();
    img.src = this.props.image;
    img.onload = () => this.props.connectDragPreview!(img);
  }

  render() {
    toggleDragginClass(this.props.isDragging!);
    return this.props.connectDragSource!(
      <div className={`imageContainer ${this.props.isDragging ? 'active' : ''}`}>
        <img className="image" src={this.props.image} />
      </div>,
    );
  }
}

const boxSource = {
  beginDrag(props: any) {
    return {
      data: {
        src: props.image,
      },
      type: placeholderTypes.Image,
    };
  },
};

function collectDrag(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

export default (
  DragSource(props => props.type, boxSource, collectDrag)
)(ImageItem);



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ImagesTab/ImageItem.tsx